import React  from 'react';   
import { Col, Container, Row } from 'react-bootstrap'; 

interface NewProcurementprops {} 
export const NewProcurement: React.FunctionComponent<NewProcurementprops> = (props) => {  
    return (  
        <React.Fragment>  
           <Container fluid> 
                <Container  className='px-0 py-4'>
                    <Row>
                        <Col sm={12} md={6} lg={4} className='mb-4'>
                            New Procurement
                        </Col>
                    </Row>
                </Container>
            </Container> 
        </React.Fragment>
    )
} 
export default NewProcurement;




